import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElBannerImage = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 0 0;
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElImage = styled.img`
  width: 100%;
  object-fit: contain;
`;
